import { Pipe, PipeTransform } from '@angular/core';

import {
    SelectedMetric,
    SelectedMetricsMap,
} from '../components/metric-by-category-list/metric-by-category-list.interface';

/**
 * Check whether a section contains selected item(s)
 *
 * value: A composite object of booleans organized by category, section, menu, and metric ids, marking which metrics
 *   have been selected.
 *
 * Params:
 *   categoryLabel: The label of a metric category; this is the broadest way metrics are grouped.
 *   sectionLabel: The label of a metric section; this is part of a category and can contain individual metrics or
 *     submenus of individual metrics.
 *   menuLabel: The label of a metric menu, if the metric is part of a submenu; not all metrics are part of submenus.
 *
 */
@Pipe({
    name: 'isSectionItemSelected',
    standalone: false,
})
export class IsSectionItemSelected implements PipeTransform {
    transform(value: SelectedMetricsMap, categoryLabel: string, sectionLabel: string): boolean {
        const section = value[categoryLabel][sectionLabel] as SelectedMetric;
        return Object.values(section).some((itemSelected: boolean) => itemSelected);
    }
}
